/**
 * Data Freshness Classes — ADR-037
 *
 * Every useQuery call MUST specify staleTime using one of these constants.
 * The class reflects how often the data changes during normal operations.
 *
 * guard-data-freshness enforces this: no inline staleTime numbers allowed.
 */

export const DATA_CLASS = {
  /** Products, industry types, PLZ zones, regions, wiki, IAM roles, app registry.
   *  Changes: monthly, by admin action. Never during field work. */
  STATIC: 24 * 60 * 60 * 1000,   // 24 hours

  /** Rep preferences, targets, permission map, company settings, themes.
   *  Changes: when admin edits settings. Not during active field work. */
  CONFIG: 30 * 60 * 1000,         // 30 minutes

  /** Page contexts (missions + leads + appointments), reporting data,
   *  scoring snapshots, CRM contact lists, purchase orders.
   *  Changes: when rep or server acts. ~5min between meaningful changes. */
  SESSION: 5 * 60 * 1000,         // 5 minutes

  /** Mission day state, lead status during active work, team reports,
   *  inventory counts during picking, order status during fulfillment.
   *  Changes: during active operations, supplemented by Realtime. */
  LIVE: 30 * 1000,                // 30 seconds

  /** Activity broadcast, presence status, live inventory updates.
   *  Delivered via Supabase Realtime channels, not polling. */
  REALTIME: 0,                    // 0 — channel-driven
} as const

export type DataClass = keyof typeof DATA_CLASS
